import Vue from 'vue';

// Event bus.
export default new Vue();
